import { Component, Input, Output, EventEmitter, OnInit, HostListener, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '../../services/events.service';
import { Navigation } from '../../interfaces/navigation';

@Component({
  selector: 'app-navigation-overlay',
  templateUrl: './navigation-overlay.component.html',
  styleUrls: ['./navigation-overlay.component.scss']
})
export class NavigationOverlayComponent implements OnInit, OnChanges {
  @Input() navigation: Navigation;
  @Input() menuOpen: boolean;
  @Output() close = new EventEmitter<boolean>();
  @ViewChild('nav') nav: ElementRef;
  desktop: boolean;

  constructor(
    private events: EventsService,
    private router: Router,
  ) { }

  focusOutFunction(r) {
    if (r === 'start') {
      document.getElementById('twitter').focus();
    } else {
      document.getElementById('nav').focus();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.desktop = window.innerWidth > 767 ? true : false;
  }

  ngOnInit() {
    this.onResize();
  }

  ngOnChanges() {
    if (this.menuOpen) {
      setTimeout(() => {
        document.getElementById('nav').focus();
      }, 100);
    }
  }

  closeOverlay($event, title, external = false) {
    let path = title.toLowerCase();

    if (!external) {
      this.router.navigate([path]);

      path = path.replace('/', '');
      this.events.broadcast('route:change', {
        path,
        intro: false,
      });
    }

    this.close.emit(true);
  }
}
